import { render, staticRenderFns } from "./UploaderToolbar.vue?vue&type=template&id=160377df&scoped=true"
import script from "./UploaderToolbar.vue?vue&type=script&lang=js"
export * from "./UploaderToolbar.vue?vue&type=script&lang=js"
import style0 from "./UploaderToolbar.vue?vue&type=style&index=0&id=160377df&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160377df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('160377df')) {
      api.createRecord('160377df', component.options)
    } else {
      api.reload('160377df', component.options)
    }
    module.hot.accept("./UploaderToolbar.vue?vue&type=template&id=160377df&scoped=true", function () {
      api.rerender('160377df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/default/UploaderToolbar.vue"
export default component.exports